module.exports = __webpack_public_path__ + "img/mini-program-redirect-page-image.15a4595d.png";